import { handleActions } from 'redux-actions';
import actions from '../../actions/cart/remove';

const INITIAL_STATE = {
    isFetching: false,
    error: null,
};

export default handleActions(
    {
        [actions.remove]: state => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [actions.success]: (state, action) => {
            return {
                ...state,
                isFetching: false,
                error: null,
                ...action.payload
            };
        },
        [actions.error]: (state, action) => {
            return {
                ...state,
                isFetching: false,
                error: action.payload
            };
        },
    },
    { ...INITIAL_STATE },
);
